import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { FormProvider, useForm } from "react-hook-form";
import { FaCheck } from "react-icons/fa";
import { FaTimes } from "react-icons/fa";

import { PaziaButton, PaziaCheckbox, PaziaTextarea } from "components/atoms";
import { useReviewExam } from "./store/reducer";
import { ReviewExamBody } from "api/userExamsApi";

interface ReviewSummaryProps {
  onSubmit: (formData: ReviewExamBody) => Promise<void>;
  defaultValues: {
    comment?: string;
    passed?: boolean;
  };
}
export const ReviewSummary = ({ onSubmit, defaultValues }: ReviewSummaryProps) => {
  const {
    state: { answers },
  } = useReviewExam();

  const methods = useForm<ReviewSummaryFromValues>({
    resolver: yupResolver(schema),
    defaultValues: {
      [REVIEW_SUMMARY_FORM_NAME.COMMENT]: defaultValues?.comment,
      [REVIEW_SUMMARY_FORM_NAME.PASSED]: defaultValues?.passed,
    },
  });
  const { handleSubmit } = methods;

  const onSubmitHandler = async (formData: ReviewSummaryFromValues) => {
    const body = {
      answers: answers.map((answer) => ({
        questionId: answer.examQuestionId,
        comment: answer.review?.comment,
        passed: answer.review?.passed,
        points: answer.review?.points,
      })),
      passed: formData.passed,
      comment: formData.comment,
    };
    onSubmit(body);
  };

  return (
    <FormProvider {...methods}>
      <div>
        {answers.map((answer, idx) => (
          <div key={answer.userExamAnswerId} className="border p-2 m-2">
            <div>
              <span className="font-semibold">Pytanie {idx + 1} </span>
              {answer.question.question}
            </div>
            <div className="flex items-center gap-2">
              <span className="font-semibold">Zaliczony: </span>
              {answer.review?.passed ? <FaCheck /> : <FaTimes />}
            </div>
            <div>
              <span className="font-semibold">Komentarz sprawdzającego: </span>
              {answer.review?.comment}
            </div>
          </div>
        ))}
        <form onSubmit={handleSubmit(onSubmitHandler)}>
          <PaziaTextarea name={REVIEW_SUMMARY_FORM_NAME.COMMENT} label="Komentarz podsumowujący" required />
          <PaziaCheckbox name={REVIEW_SUMMARY_FORM_NAME.PASSED} label="Zaliczony" />
          <div className="flex justify-end">
            <PaziaButton title="Zapisz" type="success" />
          </div>
        </form>
      </div>
    </FormProvider>
  );
};
const REVIEW_SUMMARY_FORM_NAME = {
  COMMENT: "comment",
  PASSED: "passed",
} as const;

const schema = yup
  .object({
    [REVIEW_SUMMARY_FORM_NAME.COMMENT]: yup.string(),
    [REVIEW_SUMMARY_FORM_NAME.PASSED]: yup.boolean(),
  })
  .required();

export type ReviewSummaryFromValues = yup.InferType<typeof schema>;
